module.exports = __webpack_public_path__ + "media/images/webpage/hotels/539/floorguide/onesence-5-262bd231de7c6639ec52f3b1b786aa14.webp";